import * as React from 'react';
import StepShippingAddress from './StepShippingAddress';
import StepPaymentMethod from './StepPaymentMethod';
import CheckoutMyCart from './CheckoutMyCart';
import QuoteInformationCheckout from './QuoteInformationCheckout';
import QuoteCheckoutMyCart from './QuoteCheckoutMyCart';
import { useCartStore } from 'src/hooks/cart';
import store from 'src/storeWire';
import { system_notification } from 'src/store/slice/system';
import StepShippingMethod from './StepShippingMethod';

const CheckoutSteps = (props) => {
    const [{ }, { get_cart_quote_number }, { }] = useCartStore();
    const quoteNumber = get_cart_quote_number();

    const returnToCart = () => {
        store.dispatch(system_notification({
            name: 'LeavingCheckout',
            data: { "quoteNumber": quoteNumber }
        }));
    };

    return (
        <>
            <div className="checkout-steps">
                <a href={void (0)} className="return-to-order d-inline-flex align-items-center w-auto mb-2"
                    onClick={() => { returnToCart() }} >
                    <i className='return-cart me-1'></i><span>Return to Cart</span>
                </a>
                {quoteNumber && <QuoteInformationCheckout quoteNumber={quoteNumber} />}

                <StepShippingAddress />
                {/* <StepShippingMethod /> */}
                <StepPaymentMethod />

                {quoteNumber ?
                    <QuoteCheckoutMyCart /> :
                    <CheckoutMyCart />
                }
            </div>
        </>
    );
}

export default CheckoutSteps;